<template>
  <div>
    <router-view/>
  </div>
</template>

<script>
  import '../assets/scss/myCommon.scss'

  export default {
    name: 'Home',
    components: {

    },
    methods: {},

    data() {
      return {

      }
    }
  }
</script>
